import { useState } from 'react';
import TextArea from '../../atoms/text-area';
import InputCalendar from '../../molecules/input-calendar';
import RadioButtonGroup from '../../molecules/radio-button-group';
import SectionHeader from './section-header';
import classNames from 'classnames';
import SVGIcon from '../../atoms/icons';
import { useTranslation } from 'react-i18next';
import RadioOption from '../../atoms/radio';

export interface RetroactiveMonitoringForm {
	date: Date;
	dayState: 'AM' | 'PM';
	description: string;
	isAvailable: boolean;
}

interface RetroactiveMonitoringProps {
	data: RetroactiveMonitoringForm;
	setData: React.Dispatch<React.SetStateAction<RetroactiveMonitoringForm>>;
	aoAlterarDescricao: (descricao: string) => void;
}

const RetroactiveMonitoring = ({
	data,
	setData,
	aoAlterarDescricao,
}: RetroactiveMonitoringProps) => {
	const { t } = useTranslation();

	const handleChange = (key: keyof RetroactiveMonitoringForm, value: any) => {
		setData((prev) => ({ ...prev, [key]: value }));
	};

	const handleDescricao = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const descricao = e.target.value;
		handleChange('description', descricao);
		aoAlterarDescricao(descricao);
	};

	const toggleButton = () => {
		setData((prev) => ({
			...prev,
			isAvailable: !prev.isAvailable,
		}));
	};

	return (
		<div className="grid grid-rows-[auto_1fr] sm:col-span-2 lg:col-span-1 gap-3 border border-primary rounded-lg">
			<SectionHeader title={t('monitor.retroactive')} />
			<div className="grid grid-rows-[auto_1fr_auto] gap-6 p-3">
				<InputCalendar
					date={data.date}
					onDateChange={(date) => handleChange('date', date)}
					placeholder={t('date.retroactive')}
				/>
				<div className="flex justify-between">
					<div className="flex flex-col gap-2">
						<RadioOption
							id="dayStateAM"
							name="dayState"
							label="AM"
							value="AM"
							checked={data.dayState === 'AM'}
							onChange={(e) =>
								handleChange('dayState', e.target.value)
							}
						/>
						<RadioOption
							id="dayStatePM"
							name="dayState"
							label="PM"
							value="PM"
							checked={data.dayState === 'PM'}
							onChange={(e) =>
								handleChange('dayState', e.target.value)
							}
						/>
					</div>
					<div
						className={classNames(
							'size-24 rounded-lg cursor-pointer flex items-center justify-center select-none',
							{
								'bg-green': data.isAvailable,
								'border border-dashed': !data.isAvailable,
							}
						)}
						role="button"
						onClick={toggleButton}
					>
						{data.isAvailable && (
							<SVGIcon
								className="h-12 w-auto select-none"
								icon="Check"
							/>
						)}
					</div>
				</div>
				<TextArea
					className="w-full"
					rows={4}
					placeholder={t('misc.description')}
					value={data.description}
					onChange={handleDescricao}
				/>
			</div>
		</div>
	);
};

export default RetroactiveMonitoring;
